
$(document.body).on('click mousedown keydown keyup', '.secondary_inputs input[type="radio"]', function(e){
  let radioButton = $(e.target);
  if(('keydown' === e.type  && 32 === e.keyCode) || 'mousedown' === e.type){
    radioButton.data('originally_checked', radioButton.prop('checked'));
  }
  if(('keyup' === e.type && 32 === e.keyCode) || 'click' === e.type){
    if(radioButton.data('originally_checked')){
      radioButton.prop('checked', false).removeAttr('checked');
    } else {
      radioButton.prop('checked', true).attr('checked', 'checked');
    }
    radioButton.removeData('originally_checked').trigger('done_changing');
  }
});



function new_customer_request(form){
  var formData = $(form).serialize();
  $('.thank-you-page').hide();
  // console.log(formData)
  try{
    $.ajax({
      type: "POST",
      url: Applink+'CustomerOrder/customer_request',
      dataType: "json",
      cache: false,
      data: formData,
      beforeSend: function( xhr ) {
        $('body').addClass('show-loader');
        $('.thank-you-page').hide();
        $('.form_tabs_wrapper').show();
      },
    }).done(function (data){
      $('body').removeClass('show-loader');
      console.log(data);
      if(data.error != undefined){
        if(data.error == true && data.message=="Customer already created"){
          $('.form_tabs_wrapper').hide();
          $('.thank-you-page').hide();
          $('.error-page').show();
        }
        else{
          $('.form_tabs_wrapper').hide();
          $('.thank-you-page').show();
        }
      }
      else{
        $('.form_tabs_wrapper').hide();
        $('.thank-you-page').show();
      }
    }).fail(function (textStatus){
      console.log(textStatus)
      $('.form_tabs_wrapper').show();
      $('.thank-you-page').hide();
    })
  }
  catch(ex2){
    console.log(ex2)
  }
}

$("#new_customer_request").on('submit',function(e){
  e.preventDefault();
  new_customer_request(this);
})
$("#existing_customer_request").on('submit',function(e){
  e.preventDefault();
  new_customer_request(this);
})


//Check if is_reorder_page
function is_reorder_page() {
  return $('body').hasClass('page-gemstone-reorder');
};

// const beforeUnloadListener = (event) => {
//   event.preventDefault();
//   return event.returnValue = "Are you sure you want to exit?";
// };

// const nameInput = document.querySelector("#confirm-order");

// nameInput.addEventListener("click change", (event) => {
//   if (event.target.value !== "") {
//     addEventListener("beforeunload", beforeUnloadListener, {capture: true});
//   } else {
//     removeEventListener("beforeunload", beforeUnloadListener, {capture: true});
//   }
// });

if($('body').hasClass('page-loose-gems-store') || $('body').hasClass('page-gemstone-reorder')){



  var additional_items = '<div class="single_detail"><span class="item_title">#additional_title#: </span><span class="item_value">#additional_cost#</span></div>';
  var str = '<div class="summary_item"><div class="img_wrapper"><img src="#img#"></div><div class="order_details_wrapper"><div class="single_detail"><span class="item_title">Gemstone Type: </span> <span class="item_value">#gem_type#</span></div><div class="single_detail"><span class="item_title">Gemstone Shape: </span><span class="item_value">#gem_shape#</span></div><div class="single_detail"><span class="item_title">Gemstone Size: </span><span class="item_value">#gem_size#</span></div><div class="single_detail"><span class="item_title">Average Standard Weight: </span><span class="item_value">#avg_weight#</span></div><div class="single_detail"><span class="item_title">Estimated Cost per Stone: </span><span class="item_value">#cost_per_stone#</span><span class="item_msg">Final price will be based on actual weight of gemstones.</span></div><div class="single_detail additional_costs"> <span class="item_title">Additional Costs</span></div><div class="single_detail"><span class="item_title">Quantity: </span><span class="item_value">#qty#</span></div><div class="order_actions"><a href="javascript:;" data-action="edit" data-id="#id#" class="action_link">Edit</a> <a href="javascript:;" data-id="#id#" data-action="remove" class="action_link">Remove</a></div></div></div>';



  $.ajax({
    url: Applink+'GemstoneSizes/getTypes',
    dataType: 'json',
    crossDomain: true,
    success: function (json) {
      //       console.log(json);
      $('.gemstone_shape_list').empty();
      $(".gemstone_type_list").empty();
      for (var i = 0; i < json.GemsTypes.length; i++) {
        var a = json.GemsTypes[i].Value.split('#');
        var status = JSON.parse(a[2].toLowerCase());
        var disabled = status?'':'disabled';
        var comming_soon = status?'':'<span class="coming-soon">Coming soon</span>';
        $(".gemstone_type_list").append('<li class="status-'+status+'"><input type="radio" '+disabled+' data-id="'+json.GemsTypes[i].Value+'" value="'+json.GemsTypes[i].Text+'" id="gemstone-type-'+url_slug(json.GemsTypes[i].Text)+'" name="gemstone_type"><label for="gemstone-type-'+url_slug(json.GemsTypes[i].Text)+'"><div class="gems_type_img"><img for="gemstone-type-'+url_slug(json.GemsTypes[i].Text)+'" src="'+Applink+'UploadedFiles/'+a[1]+'"/></div><span>'+json.GemsTypes[i].Text+'</span></label>'+comming_soon+'</li>');
        //         $(".gemstone_type_list").append('<li><input type="radio" data-id="'+json.GemsTypes[i].Value+'" value="'+json.GemsTypes[i].Text+'" id="gemstone-type-'+url_slug(json.GemsTypes[i].Text)+'" name="gemstone_type"><label for="gemstone-type-'+url_slug(json.GemsTypes[i].Text)+'">'+json.GemsTypes[i].Text+'</label></li>');
      }
    },
    error: function (e) {
      console.log(e);
    }
  });

  function getOrderData(customer_id,order_id, status="pending") {
    var stateUrl = Applink+'CustomerOrder/getOrderData?customer_id=' + customer_id+'&status='+status;
    if(status != 'pending' && order_id != ""){
      stateUrl = Applink+'CustomerOrder/getOrderDataforOrder?customer_id=' + customer_id+'&status='+status+'&order_id='+order_id;
    }
    $.ajax({
      url: stateUrl,
      dataType: 'json',
      crossDomain: true,
      beforeSend: function( xhr ) {
        $('body').addClass('show-loader');
        if(status!='pending'){
          $('.summary_actions').hide();
        }
      },
      success: function (json) {
        $('body').removeClass('show-loader');
        $('.order_summary_wrapper .summmary_extra_data, .order_summary_wrapper .desc, .order_summary_wrapper .summary_actions').show();
        console.log(json);
        if(json != ""){
          if(json.order_details.length>0){
            $("#order_id").val(json.order.order_id);
            $('.summary_data').empty();
            for(i=0;i<json.order_details.length;i++){
              var order_detail = json.order_details[i];
              var additional_itemsArr = json.additional_items;
              var od=order_detail;
              var t = order_detail.gem_type;
              if(order_detail.gem_match){
                t+=" - "+order_detail.gem_match;
              }
              var cost_per_stone ='';
              if(order_detail.cost_per_stone)
                cost_per_stone = order_detail.cost_per_stone;
              var avg_std_weight='';
              if(order_detail.avg_std_weight){
                avg_std_weight= order_detail.avg_std_weight;  
              }
              var default_img= 'https://cdn.shopify.com/s/files/1/1696/0571/files/box-img.jpg?v=1608190683';
              if(order_detail.img){
                default_img = Applink+'UploadedFiles/'+order_detail.img;
              }
              //               console.log(default_img,order_detail.img)
              var price = Shopify.formatMoney((cost_per_stone*100), $('body').data('money-format'));
              //               console.log(cost_per_stone)

              var item = str.replace('#gem_type#',(t)).replace('#img#',default_img).replace('#gem_shape#',order_detail.gem_shape).replace('#gem_size#',order_detail.gem_size).replace('#avg_weight#',avg_std_weight).replace('#cost_per_stone#',price).replace('#qty#',order_detail.qty).replace('#id#',order_detail.id).replace('#id#',order_detail.id);
              var summary_item = $(item);
              $('.summary_data').append(summary_item);

              // Append additional cost items
            if (od.ismatch_color === true || od.ismatch_color === "true") {
                let d = additional_items;
                let resKey = '';
  
                if (od.qty == 1) {
                  resKey = 'color-match-1';
                } else if (od.qty == 2) {
                  resKey = 'color-match-2';
                } else if (od.qty >= 3 && od.qty <= 15) {
                  resKey = 'color-match-3-to-15';
                } else if (od.qty > 15) {
                  resKey = 'color-match-15+';
                }

                const res = additional_itemsArr.find(a => a.additional_key === resKey);

                if (res) {
                  let costDisplay = '';
                 
                  if (res.additional_key === 'color-match-15+' && od.qty > 15) {
                    // Always show "Call for Quote" or similar postfix
                    costDisplay = `${res.additional_cost_title} - ${res.additional_postfix || 'Contact Us'}`;
                  } else if (parseFloat(res.additional_cost) === 0) {
                    costDisplay = `${res.additional_cost_title} - No Charge`;
                  } else {
                    costDisplay = `${res.additional_cost_title} - ${Shopify.formatMoney(res.additional_cost * 100, $('body').data('money-format'))} ${res.additional_postfix || ''}`;
                  }

                  d = d.replace('#additional_title#', 'Color Matching Gemstones')
                      .replace('#additional_cost#', costDisplay);

                  summary_item.find('.single_detail.additional_costs').append($(d));
                }
              }
              else{
                summary_item.find('.single_detail.additional_costs').remove();
              }
            }
            if(status!='pending'){
              $('.summary_actions').show();
              var order = json.order;
              $("#customer_notes").html(order.customer_notes);
              $('input[name="contact_method"], input[name="shipping_account"]').removeAttr('checked');
              if(order.contact_method=="Email"){
                $("#email_method").attr('checked',true).trigger('change');
              }
              else{
                $("#email_phone").attr('checked',true).trigger('change');
              }
              //shipping_account
//               if(order.shipping_account=="Yes"){
//                 $("#shipping_accountYes").attr('checked',true).trigger('change');
//               }
//               else{
//                 $("#shipping_accountNo").attr('checked',true).trigger('change');
//               }
              
              //ship_partial
//               if(order.ship_partial=="Yes"){
//                 $("#ship_partialYes").attr('checked',true).trigger('change');
//               }
//               else{
//                 $("#ship_partialNo").attr('checked',true).trigger('change');
//               }
              $("#ship_alternate_address").html(order.ship_alternate_address);
              //contact_discuss
//               if(order.contact_discuss=="Yes"){
//                 $("#contact_discussYes").attr('checked',true).trigger('change');
//               }
//               else{
//                 $("#contact_discussNo").attr('checked',true).trigger('change');
//               }
              
              $("#shipping_method").val(order.shipping_method).trigger('change');
//               $("#schedule_order").val(order.schedule_order);
              console.log('customer_notes')
            }
          }
        }
        else{
          $('.order_summary_wrapper .summmary_extra_data, .order_summary_wrapper .desc, .order_summary_wrapper .summary_actions').hide();
          if(status!='pending'){
//             $('.links_cta_wrapper').hide();
//             $('.summary_data').empty().append('<div class="no_orders center"><p>No Re-orders found.<br><a href="/pages/chatham-lab-grown-loose-gems-store">Click here to create new order</a></p></div>');
          }
          else{
            $('.summary_data').empty().append('<div class="no_orders center"><p>No orders found.</p></div>');
          }
            if(status!='pending'){
            $('.summary_actions').hide();
          }
        }
      },
      error: function (e) {
        console.log(e);
      }
    });
  }


  function FillShapesList(type_id) {
    var stateUrl = Applink+'GemstoneSizes/getShapes?id=' + type_id;
    $.ajax({
      url: stateUrl,
      dataType: 'json',
      crossDomain: true,
      success: function (json) {
        console.log(json);
        $('.gemstone_shape_list').empty();
        for (i = 0; i < json.GemShapes.length; i++) {
          var a = json.GemShapes[i].Value.split('#');
          $(".gemstone_shape_list").append('<li><input type="radio" data-id="'+a[0]+'" data-img="'+a[1]+'" value="'+json.GemShapes[i].Text+'" id="gemstone-shape-'+url_slug(json.GemShapes[i].Text)+'" name="gemstone_shape"><label for="gemstone-shape-'+url_slug(json.GemShapes[i].Text)+'"><img for="gemstone-shape-'+url_slug(json.GemShapes[i].Text)+'" src="'+Applink+'UploadedFiles/'+a[1]+'"/><span>'+json.GemShapes[i].Text+'</span></label></li>');
        }
      },
      error: function (e) {
        console.log(e);
      }
    });
  }

  function calc_cost_weight(){
    var val = $('#gemstone_size option:selected');
    var qty = parseInt($("#gemstone_qty").val());
    var gems_type = String($("[name='gemstone_type']:checked").val()).toLowerCase();
    // console.log(gems_type)
    var avg_cost=0,per_stone_price=0,total_cost=0;
    var price1,price2,price3,price4=0;
    var weight = parseFloat(val.attr('data-weight'));
    //       console.log(weight,gems_type)
    if(gems_type.indexOf('emerald')>=0){
      if(weight>=0.01 && weight<=0.05){
        per_stone_price=7; /*6*/
        avg_cost=7;/*6*/
      }
      else if(weight>=0.06 && weight<=4.99){
        per_stone_price=185; /*180*/
        avg_cost = weight*per_stone_price;
        total_cost=weight*per_stone_price*qty;
      }
      else if(weight>=5.0 && weight<=9.99){
        per_stone_price=225;
        //         avg_cost = weight*per_stone_price*qty;
        avg_cost = weight*per_stone_price;
        total_cost=weight*per_stone_price*qty;
      }
      else{
        per_stone_price=250;
        //         avg_cost = weight*per_stone_price*qty;
        avg_cost = weight*per_stone_price;
        total_cost=weight*per_stone_price*qty;
      }
    }
    else if(gems_type.indexOf('ruby')>=0){
      if(weight>=0.01 && weight<=0.05){
        per_stone_price=7;/*6*/
        avg_cost=7;/*6*/
      }
      else if(weight>=0.06 && weight<=4.99){
        per_stone_price=175; /*170*/
        //         avg_cost = weight*per_stone_price*qty;
        avg_cost = weight*per_stone_price;
        total_cost=weight*per_stone_price*qty;
      }
      else if(weight>=5.0 && weight<=9.99){
        per_stone_price=215;
        //         avg_cost = weight*per_stone_price*qty;
        avg_cost = weight*per_stone_price;
        total_cost=weight*per_stone_price*qty;
      }
      else{
        per_stone_price=250;
        //         avg_cost = weight*per_stone_price*qty;
        avg_cost = weight*per_stone_price;
        total_cost=weight*per_stone_price*qty;
      }
    }
    else if(gems_type.indexOf('sapphire')>=0 || gems_type.indexOf('alexandrite')>=0 || gems_type.indexOf('padparadscha')>=0){
      if(weight>=0.01 && weight<=0.05){
        per_stone_price=7; /*6*/
        avg_cost=7; /*6*/
      }
      else if(weight>=0.06 && weight<=4.99){
        per_stone_price=165; /*150*/
        //         avg_cost = weight*per_stone_price*qty;
        avg_cost = weight*per_stone_price;
        total_cost=weight*per_stone_price*qty;
      }
      else if(weight>=5.0 && weight<=9.99){
        per_stone_price=170; /*160*/
        //         avg_cost = weight*per_stone_price*qty;
        avg_cost = weight*per_stone_price;
        total_cost=weight*per_stone_price*qty;
      }
      else{
        per_stone_price=175;
        //         avg_cost = weight*per_stone_price*qty;
        avg_cost = weight*per_stone_price;
        total_cost=weight*per_stone_price*qty;
      }
    }
    else if(gems_type.indexOf('aqua')>=0){
      if(weight>=0.01 && weight<=0.05){
        per_stone_price=7;/*6*/
        avg_cost=7;/*6*/
      }
      else if(weight>=0.06){
        per_stone_price=150;
        //         avg_cost = weight*per_stone_price*qty;
        avg_cost = weight*per_stone_price;
        total_cost=weight*per_stone_price*qty;
      }
    }
    else if(gems_type.indexOf('paraiba colored')>=0 || gems_type.indexOf('chrysoberyl')>=0){
      console.log(gems_type)
      if(weight>=0.01 && weight<=0.05){
        per_stone_price=7;/*6*/
        avg_cost=7;/*6*/
      }
      else if(weight>=0.06 && weight<=4.99){
        per_stone_price=165; /*150*/
        //         avg_cost = weight*per_stone_price*qty;
        avg_cost = weight*per_stone_price;
        total_cost=weight*per_stone_price*qty;
      }
      else if(weight>=5.0 && weight<=9.99){
        per_stone_price=170; /*160*/
        //         avg_cost = weight*per_stone_price*qty;
        avg_cost = weight*per_stone_price;
        total_cost=weight*per_stone_price*qty;
      }
      else{
        per_stone_price=175;
        //         avg_cost = weight*per_stone_price*qty;
        avg_cost = weight*per_stone_price;
        total_cost=weight*per_stone_price*qty;
      }
    }
    else{
      per_stone_price=50;
      //       avg_cost = weight*per_stone_price*qty;
      avg_cost = weight*per_stone_price;
      total_cost=weight*per_stone_price*qty;
    }


    $("#avg_std_weight").val(weight.toFixed(2)).attr('value',weight.toFixed(2));
    $("#cost_per_stone").val(avg_cost.toFixed(2)).attr('value',avg_cost.toFixed(2));
    $("#total_cost").val(total_cost.toFixed(2)).attr('value',total_cost.toFixed(2));

  }

  function FillSizesList(shape_id,type_id,size_id,selected_val='') {
    console.log("type_id",type_id)
    var stateUrl = Applink+'GemstoneSizes/getSizes?shape_id='+ shape_id+"&type_id="+type_id;
    $.ajax({
      url: stateUrl,
      dataType: 'json',
      crossDomain: true,
      success: function (json) {
        console.log(json.GemShapes);
        $("#gemstone_size").empty();
        $('#gemstone_size').html('<option value="">Select Size</option>');
        var selected='';
        for (var i = 0; i < json.GemShapes.length; i++) {
          var a = json.GemShapes[i].Value.split('#');          
          var instock = true;
          if(a[2] && a[2].length>0){
            instock = JSON.parse(a[2].toLowerCase());
            // console.log(instock)
          }
          else{
            instock = false;
          }
          console.log(a[2],instock)
          if(selected_val != ''){
            //             console.log(selected_val)
            if(json.GemShapes[i].Text==selected_val){
              selected="selected";
            }
            else{selected='';}
          }
          else if(i==0){
            selected="selected";
          }
          else{selected='';}
          //           console.log(selected)
          if(instock==true){
            $("#gemstone_size").append('<option '+selected+' '+' data-id="'+a[0]+'" data-weight="'+a[1]+'" value="' + json.GemShapes[i].Text + '">' + json.GemShapes[i].Text+ '</option>');
          }
        }
        calc_cost_weight();
      },
      error: function (e) {
        console.log(e);
      }
    });
  }




  function submitForm(){
    var formData = $("#customer_order").serialize();
    $("#order_summary_wrapper").hide();
    $('.summary_data').empty();
    console.log(formData)
    var url =Applink+'CustomerOrder/Create'; 
    if(is_reorder_page() == true){
      url =Applink+'CustomerOrder/reOrderCreate';
    }
    try{
      $.ajax({
        type: "POST",
        url:url,
        dataType: "json",
        cache: false,
        data: formData,
        beforeSend: function( xhr ) {
          $('body').addClass('show-loader');
        },
      }).done(function (data){
        $('body').removeClass('show-loader');
        console.log(data);
        var customer_id = parseFloat($("#customer_id").val());
        (is_reorder_page() !=true)?getOrderData(customer_id,"","pending"):getOrderData(customer_id,"","order-pending");
        $("#main_wrapper").hide();
        $("#order_summary_wrapper").show();
      }).fail(function (textStatus){
        console.log(textStatus)
      })
    }
    catch(ex2){
      console.log(ex2)
    }
  }

  function EditForm(){
    var formData = $("#customer_order").serialize();
    $("#order_summary_wrapper").hide();
    $('.summary_data').empty();
    console.log(formData)
    try{
      $.ajax({
        type: "POST",
        url: Applink+'CustomerOrder/Edit?id='+parseInt($("#EditId").val()),
        dataType: "json",
        cache: false,
        data: formData,
        beforeSend: function( xhr ) {
          $('body').addClass('show-loader');
        }
      }).done(function (data){
        console.log(data);
        $('body').removeClass('show-loader');
        var customer_id = parseFloat($("#customer_id").val());
//         getOrderData(customer_id,"","pending");
         (is_reorder_page() !=true)?getOrderData(customer_id,"","pending"):getOrderData(customer_id,"","order-pending");
        $("#main_wrapper").hide();
        $("#order_summary_wrapper").show();
      }).fail(function (textStatus){
        console.log(textStatus)
      })
    }
    catch(ex2){
      console.log(ex2)
    }
  }

  $('input[name=contact_method]').on('change',function(){
    var val = $(this).val();
    $('.method_contact_wrapper>.error').addClass('hidden');
    if(val=='Phone'){
      $('.phone-div').removeClass('hidden');
    }
    else{
      $('.phone-div').addClass('hidden');
    }
  })


  $('input[name=shipping_account]').on('change',function(){
    var val = $(this).val();
    console.log(val)
    if(val=='No'){
      if($('#shopify_customer_address').val().length>0){
        $("#ship_alternate_address").val('')
        $("#ship_alternate_addr").removeClass('hidden');
      }
      else{
        $("#ship_alternate_address").val('')
        $("#ship_alternate_addr").addClass('hidden');
      }
    }
    else{
      $("#ship_alternate_address").val('')
      $("#ship_alternate_addr").addClass('hidden');
    }
  })

  $(".price_list").on('click',function(e){
    e.preventDefault();
    $('.wholesale-price-list').toggleClass('active-list');
  })

  $(".close-popup").on('click',function(e){
    e.preventDefault();
    $('.wholesale-price-list').removeClass('active-list');
  })



  $('.tab_header').on('click',function(e){
    e.preventDefault();
    var ele = $(this).siblings('.tab_data');
    $('.tab_data').not(ele).hide();
    $(this).siblings('.tab_data').toggle();    
    //     $('.tab_data').show();
  })
  $('.btn_wrappers .action_button').on('click',function(e){
    e.preventDefault();
    var action = $(this).attr('data-action');

    $('html, body').animate({
      scrollTop: $('.main-tabs-wrapper').offset().top
    }, 100);
    if(action=='next'){
      var parent = $(this).parents('.tab').next();
      $('.tabs_wrapper .tab_data').hide();
      parent.find('.tab_data').show();
      if($(this).parents('.tab').hasClass('tab2')){
//         console.log('tab 2')
        var type_id= parseInt($("input[name=gemstone_type]:checked").attr('data-id'));
        var shape_id= parseInt($("input[name=gemstone_shape]:checked").attr('data-id'));
        //         var shape_id= parseInt($("input[name=gemstone_shape]:checked").attr('data-id'));
        FillSizesList(shape_id,type_id);
      }
      if($(this).hasClass('submit-button')){
        if($("input[name=gemstone_type]:checked").length==0){
          alert('Please select Gemstone Type')
          $('.tab1 .tab_header').trigger('click');
        }
        else if($("input[name=gemstone_shape]:checked").length==0){
          alert('Please select Gemstone Shape')
          $('.tab2 .tab_header').trigger('click');
        }
        else if($("#gemstone_size option:selected").val()==''){
          alert('Please select Gemstone Size')
          $('.tab3 .tab_header').trigger('click');
        }
        else{
          console.log($("#isEdit").val())
          if($("#isEdit").val() == false || $("#isEdit").val() == 'false'){
            submitForm();
          }
          else{EditForm();}
        }
      }
    }
    else{
      var parent = $(this).parents('.tab').prev();
      $('.tabs_wrapper .tab_data').hide();
      parent.find('.tab_data').show()
    }
  })

  $('body').on("change", "input[name='gemstone_type']", function() {
    $("input[name='gemstone_type']").removeAttr("checked");
    var val = $("input[name='gemstone_type']:checked").attr('data-id');
//     console.log(val)
    var str_val = $("input[name='gemstone_type']:checked").val();
    FillShapesList(val);
    SmoothScroll("match_selectors","-",120)
    
    if(str_val==='Champagne Sapphire - True'){
      window.champagne_sapphire_modal.open();
    }
    //     $('.tab2 .tab_header').trigger('click');
  })

  $("body").on('change','input[name=gemstone_shape]',function(){
    var val = $("input[name=gemstone_shape]:checked").attr('data-img');
    //     console.log(val)
    $("#img").val(val)
    var type_id= parseInt($("input[name=gemstone_type]:checked").attr('data-id'));
    var shape_id= parseInt($("input[name=gemstone_shape]:checked").attr('data-id'));
    FillSizesList(shape_id,type_id);
    $("#tab2 .tab_data").slideUp(1500,function(){$('.tab3 .tab_header').trigger('click');});

  })

  $('#gemstone_size').on('change',function(){
    calc_cost_weight();
  })

  $("#gemstone_qty").on('change',function(){
    calc_cost_weight();
  })


  var customer_id = parseFloat($("#customer_id").val());
  if(is_reorder_page() == false){
//     console.log('getOrderDatas',is_reorder_page)
    getOrderData(customer_id,"","pending");
  }
  else{
    var get_encodedId = Shopify.urlParam('id');
    if(get_encodedId){
      var decodedParams = decodeURI(atob(get_encodedId))
      var jsonArray=stringToJson(decodedParams);
      console.log(jsonArray)
      getOrderData(customer_id,jsonArray.id,"order-pending");
      $("#order_summary_wrapper").show();
      $("#main_wrapper").hide();
      $('.thank-you-page').hide();
    }
  }
 



  $('input[name="match"]').on('change',function(){
    var val = $(this).val();
    if(val=="Match Consistency"){
      $("#ismatch_color").val(false)
      $("#ismatch_consistency").val(true)
    }
    else{
      $("#ismatch_color").val(true)
      $("#ismatch_consistency").val(false)
    }
  })
  $(".add_more_gems, #another-order").on('click',function(e){
    e.preventDefault();
    $('.tab_data.first-tab').show();
    $("#customer_order").trigger('reset');
    $("#isEdit,#ismatch_consistency,#ismatch_color").val(false);
    $("[type=radio]").removeAttr('checked').prop('checked',false);
    $("#EditId,#img").val('');
    $("#order_summary_wrapper").hide();
    $("#main_wrapper").show();
    $('.thank-you-page').hide();
  })

  $(".back_to_order_summary").on('click',function(e){
    e.preventDefault();
    $("#order_summary_wrapper").show();
    $("#main_wrapper").hide();
    $('.thank-you-page').hide();
  })

  var shipping_modal = $('[data-remodal-id=shipping-details-remodal]').remodal({hashTracking: false,closeOnOutsideClick: true});
  window.champagne_sapphire_modal = $('[data-remodal-id=true-champagne-sapphire-remodal]').remodal({hashTracking: false,closeOnOutsideClick: false});

  $("body").on('click','#gemstone-type-champagne-sapphire-true',function(){
    window.champagne_sapphire_modal.open();
  })
  function confirm_order(){


    var customer_notes = $("#customer_notes").val();
    var contact_method =$("input[name='contact_method']:checked").val();
    var contact_no = $("#contact_phone").val();
    var shipping_method = $("#shipping_method").val();

    var shipping_account =$("input[name='shipping_account']:checked").val();
    var ship_alternate_address = $("#ship_alternate_address").val();

    console.log(ship_alternate_address.length,$("input[name='shipping_account']:checked").val())
    $('em.error').addClass('hidden');
    if($("input[name='shipping_account']:checked").val()=="No" && ship_alternate_address.length<=0){
      $('#ship_alternate_address').siblings('.error').removeClass('hidden');
      return false;
    }
    else if($("input[name='shipping_notes']:checked").val()==undefined && $("input[name='shipping_notes']:checked").length<=0){
      $('.method-wapper.shipping_notes').siblings('.error').removeClass('hidden');
      return false;
    }
    else{   

      $('em.error').addClass('hidden');
      shipping_modal.close();
      var fd = new FormData();
      fd.append( 'order_id',$("#order_id").val());
      fd.append( 'customer_id',$("#customer_id").val());
      fd.append( 'customer_email',$("#customer_email").val());
      fd.append( 'shopify_default_address',$("#shopify_customer_address").val());
      fd.append( 'shopify_contact_name',$("#customer_name").val());
      fd.append( 'shopify_email',$("#customer_email").val());
      fd.append( 'shopify_phone_number',$("#customer_phone").val());
      fd.append( 'shopify_company_name',$("#company_name").val());
      fd.append( 'shopify_contact_title',$("#contact_title").val());
      fd.append( 'shopify_website',$("#website").val());
      fd.append( 'shopify_jbt_number',$("#jbt_number").val());
      fd.append( 'customer_city',$("#customer_city").val());
      fd.append( 'customer_state',$("#customer_state").val());
      fd.append( 'customer_zipcode',$("#customer_zipcode").val());
      fd.append( 'customer_notes',customer_notes);
      fd.append( 'contact_method',contact_method);
      fd.append( 'contact_phone',contact_no);
      fd.append( 'shipping_method',shipping_method);
      fd.append( 'shipping_account',$("[name=shipping_account]:checked").val());
      fd.append( 'ship_alternate_address',$("#ship_alternate_address").val());
      fd.append( 'ship_my_order',$("[name=ship_my_order]").val());
      fd.append( 'schedule_order','');
      fd.append( 'ship_partial','');
      fd.append( 'contact_discuss','');
      fd.append( 'shipping_notes',$('[name="shipping_notes"]:checked').val());

      try{
        $.ajax({
          type: "POST",
          url: Applink+'CustomerOrder/SubmitOrder',
          dataType: "json",
          processData: false,
          contentType: false,
          cache: false,
          data: fd,
          beforeSend: function( xhr ) {
            $('body').addClass('show-loader');
            $('.thank-you-page').hide();
          },
        }).done(function (data){

          $('body').removeClass('show-loader');
          console.log(data);
          var customer_id = parseFloat($("#customer_id").val());
          //          getOrderData(customer_id);
          $("#main_wrapper").hide();
          $("#order_summary_wrapper").hide();
          if(is_reorder_page() == false){
          $('.thank-you-page').show();
          }
          else{
            $('.thank-you-page').show();
            setTimeout(function(){ window.location.href="/account";}, 1000);
          }
          $("#customer_order").trigger('reset');
          $("#isEdit,#ismatch_consistency,#ismatch_color").val(false);
          $("[type=radio]").removeAttr('checked').prop('checked',false);
          $("[type=radio][name='shipping_account'][value='Yes']").attr('checked','checked').prop('checked',true);
          $("#EditId,#img").val('');
          $("#order_summary_wrapper").hide();
          getOrderData(customer_id,"");
        }).fail(function (textStatus){
          console.log(textStatus)
          $('.thank-you-page').show();
        })
      }
      catch(ex2){
        console.log(ex2)
      }
    }
  }

  $("input[name='contact_method'], #contact_phone, #shipping_method, input[name='shipping_account'], #ship_alternate_address, input[name='shipping_notes']").on('change blur keyup keypress',function(e){
    var val = $(this).val();
    var target = $(e.target);
    console.log(target.attr('name'))
    if(val.length>0){
      $(this).siblings('em.error').addClass('hidden');
      $('.method-wapper.shipping_notes').siblings('em.error').addClass('hidden');
      if(target.attr('name')=="contact_method" || target.attr('name')=="shipping_account"){
        $(this).parents('.method-wapper').siblings('em.error').addClass('hidden');
      }
    }
    else{
      $(this).siblings('em.error').removeClass('hidden');
      if(target.attr('name')=="contact_method" || target.attr('name')=="shipping_account"){
        $(this).parents('.method-wapper').siblings('em.error').removeClass('hidden');
      }
    }
  })

  $("#confirm-order").on('click',function(e){
    e.preventDefault();
    //     var customer_notes = $("#customer_notes").val();
    var contact_method =$("input[name='contact_method']:checked").val();
    var contact_no = $("#contact_phone").val();
    var shipping_method = $("#shipping_method").val();

    var errorCounter = 0;
    if($("input[name='contact_method']:checked").length==0){
      $('.method_contact_wrapper>.error').removeClass('hidden');
      errorCounter++;
    }
    else if(contact_no.length==0 && contact_method=="Phone"){
      $("#contact_phone").siblings('em.error').removeClass('hidden');
      //       return false;
      errorCounter++;
    }
    else if(shipping_method.length==0){
      $("#shipping_method").siblings('em.error').removeClass('hidden');
      //       return false;
      errorCounter++;
    }
    else{
      $('em.error').addClass('hidden');
      shipping_modal.open();
    }
  })

  $("#confirm-order2").on('click',function(e){
    e.preventDefault();
    confirm_order();
  })

  $("body").on('click','[data-action="edit"]',function(e){
    e.preventDefault();
    var id=parseInt($(this).attr('data-id'));
    var stateUrl = Applink+'CustomerOrder/getOrderDetals?id=' + id;
    $.ajax({
      url: stateUrl,
      dataType: 'json',
      crossDomain: true,
      beforeSend: function( xhr ) {
        $('body').addClass('show-loader');
      },
      success: function (json) {
        console.log(json);
        $('body').removeClass('show-loader');
        $("input[name='gemstone_type'], input[name='match'], input[name='gemstone_shape']").removeAttr('checked');
        $("input[name='gemstone_type'][value='"+json.order_details.gem_type+"']").attr('checked',true);
        $("input[name='match'][value='"+json.order_details.gem_match+"']").attr('checked',true);
        $("input[name='match']").trigger('change');
        var checked_type = $("input[name='gemstone_type']:checked").attr('data-id');
        FillShapesList(checked_type);
        setTimeout(function(){ 
          $("input[name='gemstone_shape'][value='"+json.order_details.gem_shape+"']").attr('checked',true); 
          var type_id= parseInt($("input[name=gemstone_type]:checked").attr('data-id'));
          var shape_id= parseInt($("input[name=gemstone_shape]:checked").attr('data-id'));
          $('input[name=gemstone_shape]').trigger('change');
          var size_id=(json.order_details.gem_size)
          console.log(type_id,shape_id,size_id)
          FillSizesList(shape_id,type_id,size_id,size_id);

          $("#gemstone_qty").val(json.order_details.qty);
          $('#isEdit').val(true);
          $("#EditId").val(id);
          $("#main_wrapper").show();
          $("#order_summary_wrapper").hide();
          $('.tab1 .tab_header').trigger('click');
        }, 500);
      },
      error: function (e) {
        console.log(e);
      }
    });
  })


  $("body").on('click','[data-action="remove"]',function(e){
    e.preventDefault();
    var id=parseInt($(this).attr('data-id'));
    var stateUrl = Applink+'CustomerOrder/removeOrderDetals?id=' + id;
    $.ajax({
      url: stateUrl,
      dataType: 'json',
      crossDomain: true,
      beforeSend: function( xhr ) {
        $('body').addClass('show-loader');
      },
      success: function (json) {
        //          console.log(json);
        $('body').removeClass('show-loader');
        var customer_id = parseFloat($("#customer_id").val());
//         getOrderData(customer_id,"");
        getOrderData(customer_id,"","pending");
        $("#main_wrapper").hide();
        $("#order_summary_wrapper").show();
      },
      error: function (e) {
        console.log(e);
      }
    });
  })

}

if($('body').hasClass('active-customer')){
  
  //     console.log(Shopify.customer_id)
  function getCustomerOrderData(id){
    $.ajax({
      url: Applink+'CustomerOrder/getCustomerdata?id='+id,
      dataType: 'json',
      crossDomain: true,
      beforeSend: function( xhr ) {
        $('body').addClass('show-loader');
        $('.thank-you-page').hide();
      },
      success: function (json) {
//         console.log(json);
        var orders = json;
        var $tr = "";
        $('body').removeClass('show-loader');
        if(orders.length == 0 && shopify_order_count == 0){
          $("#no_orders_msg").removeClass('hidden')
        }
        if(orders.length>0){
          
          for(var i=0;i<orders.length;i++){
            //             console.log(orders[i]["date_added"])
            var idStr = 'id='+orders[i]["order_id"]+'&customer_id='+orders[i]["customer_id"]+'';
            var encoded_id=btoa(encodeURI(idStr));
            var s=orders[i]["date_updated"];
            if(s != null){
//               console.log(s)
              var dt = Number(s.substring(6,s.lastIndexOf(')')))
              }
            else{
              s=orders[i]["date_added"];
              var dt = Number(s.substring(6,s.lastIndexOf(')')))
            }
            var newDate = new Date(dt);
            var date = newDate.toJSON().slice(0, 10);
            var nDate = date.slice(5, 7) + '/' +date.slice(8, 10) + '/' 
            + date.slice(0, 4);
//             console.log(nDate)
            $tr += `<tr><td><a data-id="${orders[i]["order_id"]}" href="/pages/gemstone-view-reorder?id=${encoded_id}" target="_blank" data-email="${orders[i]["customer_email"]}" data-action="view-order">${orders[i]["order_id"]}</a></td><td>${orders[i]["customer_name"]}</td><td><b>Email:</b> ${orders[i]["customer_email"]}<br><b>Preferred Method of Contact:</b>${orders[i]["contact_method"]}<br><b>Phone:</b>${orders[i]["contact_phone"]}</td>`;
            $tr += `<td>${orders[i]["shipping_method"]}</td>`;
            $tr += `<td>${orders[i]["status"]}</td><td>${nDate}</td><td><a data-id="${orders[i]["order_id"]}" href="/pages/gemstone-view-reorder?id=${encoded_id}" target="_blank" data-email="${orders[i]["customer_email"]}" data-action="view-order">View/Re-Order</a></td></tr>`;
          }
          $(".customer-orders table>tbody").empty().append($tr);
          $('.customer-orders').show();
          $(".customer-orders table").DataTable({
            responsive: true,
            dom: 'Bflrtip', pageLength:50
          });
        }
        else{
          $('.customer-orders').hide();
        }
        //           console.log($tr)
      },
      error: function (e) {
        console.log(e);
      }
    });
  }
  
  if($('body').hasClass('customers-account')){
    getCustomerOrderData(Shopify.customer_id);

  }
  else{
   
  }

  $(document).on('click','[data-action="reorder"]',function(e){
    var id = $(this).attr('data-id'), email=$(this).attr('data-email');
    var idStr = 'id='+id+'&email='+email+'';
    var encoded_id=btoa(encodeURI(idStr));
    $.ajax({
      type: "POST",
      url: Applink+'CustomerOrder/reorder',
      dataType: "json",
      cache: false,
      data:{id:id,email:email},
      beforeSend: function( xhr ) {
        $('body').addClass('show-loader');
      },
    }).done(function (data){
      $('body').removeClass('show-loader');
      console.log(data)

      if(data!=null || data != undefined){
        var new_orderid = data.order.order_id;
        var idStr = 'id='+new_orderid+'&email='+email+'';
        var encoded_id=btoa(encodeURI(idStr));
        //         alert('Your order has been created successfully.');
        window.location.href='/pages/gemstone-reorder?id='+encoded_id;
      }
    })
  })

  $(document).on('click','[data-action="view-order"]',function(e){
    var id = $(this).attr('data-id'), email=$(this).attr('data-email');
    if(id && email){
      Cookies.set('viewoeder_clicked', true, { expires: 1, path: '/' });
    }
  })

}

if($('body').hasClass('page-gemstone-view-reorder')){

  function loadDataTable(){
    var DtObj = $("#datatable-products").DataTable({
      dom: "Bfrtip",
      responsive: true,
      language: {
        processing: '<i class="fa fa-spinner fa-spin fa-3x fa-fw"></i><span class="sr-only">Loading...</span>'
      },
      filter: true,
      pageLength: 50,
      buttons: [
        {
          extend: "copy",
          className: "btn-sm"
        },
        {
          extend: "csv",
          className: "btn-sm"
        },
        {
          extend: "excel",
          className: "btn-sm"
        },
        {
          extend: "pdfHtml5",
          className: "btn-sm"
        },
        {
          extend: "print",
          className: "btn-sm"
        }
      ]

    });
    return DtObj;
  }

  $(document).ready(function(){
    Handlebars.registerHelper("inc", function(value, options)
                              {
      return parseInt(value) + 1;
    });
    Handlebars.registerHelper("math", function(lvalue, operator, rvalue, options) {
      lvalue = parseFloat(lvalue);
      rvalue = parseFloat(rvalue);

      return {
        "+": lvalue + rvalue,
        "-": lvalue - rvalue,
        "*": lvalue * rvalue,
        "/": lvalue / rvalue,
        "%": lvalue % rvalue
      }[operator];
    });

    Handlebars.registerHelper('safeColorMatchCost', function (colorMatchCost, fallbackValue) {
      return (colorMatchCost == null || isNaN(colorMatchCost)) ? fallbackValue : colorMatchCost;
    });


    var get_encodedId = Shopify.urlParam('id');
    var viewoeder_clicked = Cookies.get('viewoeder_clicked');
    console.log("viewoeder_clicked "+viewoeder_clicked, get_encodedId)
    if(viewoeder_clicked != undefined){
      if(get_encodedId.length>0 && JSON.parse(viewoeder_clicked) == true){
        var decodedParams = decodeURI(atob(get_encodedId))
        //       console.log(decodedParams);
        var jsonArray=stringToJson(decodedParams);
        console.log(jsonArray)

        $.ajax({
          url: Applink+'CustomerOrder/getCustomerOrderJson?id='+jsonArray.id+'&customer_id='+jsonArray.customer_id,
          dataType: 'json',
          crossDomain: true,
          beforeSend: function( xhr ) {
            $('body').addClass('show-loader');
          },
          success: function( data ) {
            console.log(data)
            $('body').removeClass('show-loader');
            var orderDetails;
            $('[data-action="reorder"]').attr('data-id',data.customerOrder.order_id);
            $('[data-action="reorder"]').attr('data-email',data.customerOrder.customer_email);
            if(data.orderDetails){
              orderDetails= data.orderDetails;
            }
            var templateSource   = $("#order_table_template").html();
            var template = Handlebars.compile(templateSource);
            var studentHTML = template({items:orderDetails});
            $('#datatable-products tbody').html(studentHTML);

            var templateSource   = $("#customer_info_table_template").html();
            var template = Handlebars.compile(templateSource);
            //               console.log(data)
            var studentHTML = template({model:data});
            $('#customer_info_table').html(studentHTML);

            var templateSource   = $("#shipping_info_table_template").html();
            var template = Handlebars.compile(templateSource);
            var studentHTML = template({model:data});
            $('#shipping_info_table').html(studentHTML);

            loadDataTable();
            //               $.each(orderDetails,function(index,obj){

            //               })
          },
        })
      }
    }
    else{
      location.href='/account';
    }
  })
}

